const aboutAR = {
  seo: {
    title: "من نحن | QuadroCode",
    description:
      "QuadroCode شركة برمجيات مبنية على رؤية عائلية، وإرشاد تقني، ونمو مهني طويل المدى.",
  },
  hero: {
    eyebrow: "من نحن",
    title: "نبني المستقبل جيلا بعد جيل",
    lead:
      "QuadroCode ليست مجرد شركة تطوير برمجيات. إنها مهمة طويلة المدى تقوم على الرؤية والمسؤولية والإيمان بأن بناء الكفاءات يبدأ مبكرا عبر العمل الحقيقي.",
  },
  story: {
    eyebrow: "قصة QuadroCode",
    title: "من فكرة عائلية إلى شركة برمجيات حقيقية",
    paragraphs: [
      "اسم Quadro يرمز إلى الأطفال الأربعة الذين ألهموا تأسيس الشركة. ما بدأ كفكرة بسيطة لتشجيع تعلم البرمجة تحول إلى هدف أكبر: بناء تقنيات عملية، ومنتجات مفيدة، وأعمال رقمية مستدامة.",
      "اليوم يشارك اثنان من الأطفال الأربعة بشكل فعلي في الشركة. يركز أحدهما على تطوير الواجهة الخلفية ومنطق الأنظمة، بينما يركز الآخر على تطوير الواجهة الأمامية وتجربة المستخدم. هما لا يتعلمان البرمجة فقط، بل يبنيان أساسا مهنيا لمستقبلهما في المجال التقني.",
    ],
  },
  vision: {
    eyebrow: "الرؤية العائلية",
    title: "لماذا وُجدت QuadroCode",
    quote: "المهارات التي تُبنى مبكرا تتحول إلى إتقان لاحقا.",
    paragraphs: [
      "تأسست QuadroCode لتطوير ما هو أبعد من المعرفة التقنية وحدها. الهدف هو بناء جيل من محللي المشكلات والمطورين ورواد الأعمال الذين يفهمون كيف تصنع التكنولوجيا قيمة حقيقية في العالم العملي.",
      "تم تصميم الشركة برؤية استمرارية واضحة. ومع نمو الطفلين الأصغر سنا ووصولهما إلى سن 15، سينضمان إلى هذه الرحلة كلٌ بطريقه ومهاراته التقنية الخاصة.",
    ],
  },
  mentorship: {
    eyebrow: "إرشاد قائم على الخبرة",
    title: "قيادة عبر التوجيه لا عبر الواجهة",
    paragraphs: [
      "تقف خلف هذه الرحلة خبرة أب بدأت رحلته التقنية منذ عام 1992 مع Assembly و C و C++، في مرحلة كانت تتطلب فهما عميقا ودقة عالية في بناء الأنظمة.",
      "ومع مرور السنوات، تطورت هذه الخبرة إلى بناء منصات وأنظمة برمجية وأعمال تقنية. واليوم، بصفته قائدا لشركة في قطاع التقنية المالية، يقدم خبرة واسعة في هندسة البرمجيات، وتصميم الأنظمة، والتنفيذ الاستراتيجي.",
      "في QuadroCode يتم توجيه هذه الخبرة إلى الجيل الجديد. الدور ليس قيادة التنفيذ اليومي للبرمجة، بل الإرشاد والتوجيه لبناء الانضباط التقني وطريقة التفكير اللازمة لتطوير برمجيات ذات أثر.",
    ],
  },
  learning: {
    eyebrow: "التعلم عبر البناء",
    title: "مشاريع حقيقية ومعايير حقيقية ونمو حقيقي",
    bullets: ["نبني أشياء حقيقية.", "نحل مشكلات حقيقية.", "نسلم برمجيات حقيقية."],
    paragraphs: [
      "في QuadroCode لا يقتصر التعلم على الجانب النظري. كل مشروع، من المواقع والمنصات الرقمية إلى الحلول البرمجية المخصصة، يمثل تسليما فعليا للعميل وفي الوقت نفسه مساحة تدريب للنمو التقني طويل المدى.",
      "بهذا النهج، يتقدم الابتكار والتعليم معا، وتصبح الجودة معيارا مهنيا واضحا منذ اليوم الأول.",
    ],
  },
  future: {
    eyebrow: "الرؤية الحالية والمستقبلية",
    title: "مصممة للحاضر ومبنية للأجيال",
    paragraphs: [
      "QuadroCode اليوم شركة برمجيات صغيرة بطموح واضح. ورؤيتها طويلة المدى هي التحول إلى استوديو تقني عائلي يجمع بين الإبداع الشاب والخبرة الهندسية المتراكمة.",
      "ومع انضمام الأطفال الأربعة جميعا بشكل تدريجي، ستمثل QuadroCode تماما ما يعبر عنه اسمها: أربعة عقول تبني المستقبل معا.",
    ],
    missionTitle: "رسالتنا",
    missionText:
      "تقديم حلول برمجية عملية وموثوقة، مع تنمية الجيل القادم من بناة التكنولوجيا. لأن أفضل طريقة للاستعداد للمستقبل هي البدء في بنائه اليوم.",
  },
  cta: {
    eyebrow: "لنبدأ الحديث",
    title: "اعمل مع فريق يبني البرمجيات برؤية طويلة المدى",
    text:
      "إذا كنت تبحث عن شريك برمجي جاد يجمع بين وضوح الرؤية والانضباط الهندسي، فإن QuadroCode جاهزة للتعاون.",
    primary: "ناقش مشروعك",
    secondary: "استكشف الخدمات",
  },
};

export default aboutAR;
